import CloseButton from './CloseButton.view';

export default CloseButton;
